import InputFactory from "../../../../components/InputFactory";

export default function PayrollReportsFilters({
  employee,
  filterEpoch = 0,
  onEmployeeChange,
}) {
  return (
    <>
      <hr className="mt-3 mb-2" />
      <p
        className="text-muted mb-2"
        style={{ fontSize: ".8rem", fontWeight: 600 }}
      >
        Filters
      </p>

      <div className="row g-2">
        <div className="col-12 col-md-6">
          <InputFactory
            key={`employee-payroll-${filterEpoch}`}
            type="Pointer"
            placeholder="Select employee"
            target="employees"
            field="employee"
            loadOnFocus
            object={employee ? { employee } : { employee: null }}
            include={["employmentType"]}
            keys={["Firstname", "Middlename", "surname"]}
            onChange={onEmployeeChange}
          />
        </div>
      </div>
    </>
  );
}
